export const normalizeApiBaseUrl = (raw) => {
  const trimmed = String(raw ?? '').trim();
  if (!trimmed) return '/api';

  const normalized = trimmed.replace(/\/+$/, '');
  if (!normalized) return '/api';

  if (normalized === '/api' || normalized.endsWith('/api')) return normalized;
  return `${normalized}/api`;
};

export const API_BASE_URL = normalizeApiBaseUrl(process.env.REACT_APP_API_BASE_URL);

